module.exports = __webpack_public_path__ + "static/media/02 Meteor Duck.9a146b66.webp";